import React from 'react';
import ReactDOM from 'react-dom/client';
import './output.css';
import Chat from './chat.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Chat />
  </React.StrictMode>
);